import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=074c5dfa"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074c5dfa')) {
      api.createRecord('074c5dfa', component.options)
    } else {
      api.reload('074c5dfa', component.options)
    }
    module.hot.accept("./translate.vue?vue&type=template&id=074c5dfa", function () {
      api.rerender('074c5dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/ticketModule/translate.vue"
export default component.exports